import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  padding: ${({ theme }) => theme.spacing[4]}px
    ${({ theme }) => theme.spacing[6]}px;

  gap: ${({ theme }) => theme.spacing[5]}px;
`;

export const ContainerHeader = styled.div`
  display: flex;
  flex-direction: column;

  padding-top: ${({ theme }) => theme.spacing[5]}px;

  gap: ${({ theme }) => theme.spacing[5]}px;
`;

export const PlanoInfoTextos = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[2]}px;
`;

export const SideContainers = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  padding-bottom: ${({ theme }) => theme.spacing[5]}px;
  gap: ${({ theme }) => theme.spacing[7]}px;
`;

export const ContainerPlanoInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const ContainerAcoesPlanos = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${({ theme }) => theme.spacing[5]}px;
`;

export const PlanoImagem = styled.div`
  position: relative;
  height: 200px;
  max-width: 460px;
`;

export const ContainerAccordion = styled.div`
  display: flex;
`;

export const ContainerBotoesPlano = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const ContainerBotoesCompra = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing[5]}px;
`;

export const ContainerBotaoTermo = styled.div`
  display: flex;
  align-self: center;
`;

export const ContainerEscolhaValor = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const BotaoEscolhaPlano = styled.button`
  background: none;
  outline: none;
`;

export const ContainerPrecoPlano = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: ${({ theme }) => theme.spacing[2]}px;
`;

export const ContainerCarrinho = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  justify-content: space-between;
`;

export const ContainerBeneficios = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[3]}px;
  max-width: 350px;
`;

export const ContainerPrecos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;

  gap: ${({ theme }) => theme.spacing[1]}px;
`;

export const ContainerDetalhesAccordion = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerPlanos = styled.div`
  display: flex;
  flex-direction: column;

  padding-bottom: ${({ theme }) => theme.spacing[5]}px;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing[4]}px;

  padding: 0 ${({ theme }) => theme.spacing[4]}px;
`;
